module.exports = __webpack_public_path__ + "img/pattern3.bcc90c3.svg";